import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { Link, Route, Switch, Redirect, withRouter } from "react-router-dom";
import withWidth, { isWidthUp } from "@material-ui/core/withWidth";

import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Routes from "./Routes.jsx";

import CheckWebP from "../Common/CheckWebP";
import gcc from "../Media/gcc.jpg";
import gccWebP from "../Media/gcc.webp";
import text from "../Media/text.png";
// import VideoCard from "../Cards/VideoCard.jsx";

import firebase from "firebase/app";
import "firebase/auth";
import ReactGA from "react-ga";

const styles = theme => ({
  root: {
    flexGrow: 1,
    zIndex: 4,
    backgroundColor: theme.palette.background.paper
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    [theme.breakpoints.down(400 + theme.spacing(3) * 2)]: {
      padding: "0"
    },
    paddingTop: "380px",
    height: "calc(100vh - 60px)",
    overflow: "scroll",
    backgroundImage: `url(${CheckWebP() ? gccWebP : gcc})`,
    backgroundSize: "cover"
  },
  tabs: {
    width: "calc(100% - 162px)",
    [theme.breakpoints.down(400 + theme.spacing(3) * 2)]: {
      width: "calc(100% - 20px)"
    }
  },

  imageDiv: {
    height: 60,
    width: 125,
    marginLeft: 10,
    backgroundImage: `url(${text})`,
    [theme.breakpoints.down(400 + theme.spacing(3) * 2)]: {
      height: 30,
      width: 60
    },
    backgroundSize: "contain",
    backgroundRepeat: "no-repeat"
  },
  toolbar: {
    minHeight: 59,
    paddingLeft: 0,
    zIndex: 100
  },
  appBarSpacer: {
    height: 60
  }
});

class IconLabelTabs extends React.Component {
  constructor() {
    super();
    this.state = {
      newLocation: { pathname: "/" },
      authenticated: false,
      volunteer: false
    };
  }

  handleChange = (event, nextLocation) => {
    this.setState({ nextLocation });
    // this.handleScroll();
    ReactGA.pageview(nextLocation);
  };

  componentWillMount = () => {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        if (
          user.email.indexOf("idanmantzor") !== -1 ||
          user.email.indexOf("dsterhaar") !== -1
        ) {
          this.setState({ authenticated: true, volunteer: true });
        } else {
          this.setState({ authenticated: false, volunteer: true });
        }
      } else {
        this.setState({ authenticated: false, volunteer: false });
      }
    });
  };

  componentDidMount = () => {
    // var main = document.getElementById("main");
    // main.addEventListener("scroll", this.handleScroll);
    // this.handleScroll();
  };

  componentWillReceiveProps = nextProps => {
    if (!this.state.authenticated) {
      this.setState({
        newLocation: { pathname: "/" }
      });
      return;
    }

    if (nextProps.location !== this.props.location) {
      this.setState({
        newLocation: nextProps.location
      });
      this.handleChange(null, nextProps.location.pathname);
    }
  };

  // handleScroll = () => {
  //   var main = document.getElementById("main");
  //   var banner = document.getElementById("banner");
  //   var hide =
  //     (this.state.nextLocation !== undefined &&
  //       this.state.nextLocation !== "/dashboard") ||
  //     (this.state.nextLocation === undefined &&
  //       this.state.newLocation.pathname !== "/dashboard");
  //   var screenWidth = window.screen.width;
  //   var bannerHeight = screenWidth < 600 ? 300 : 599;
  //   if (hide) {
  //     banner.style.height = 0;
  //     main.style.paddingTop = 0;
  //     return;
  //   } else {
  //     main.style.paddingTop = bannerHeight - 120 + "px";
  //     banner.style.height = bannerHeight + "px";
  //   }
  //   if (bannerHeight - main.scrollTop < 159 || hide) {
  //     banner.style.height = 0;
  //   } else {
  //     banner.style.height = bannerHeight - main.scrollTop + "px";
  //   }
  // };
  render() {
    const { classes, location } = this.props;
    const { newLocation, authenticated, volunteer } = this.state;

    return (
      <React.Fragment>
        <CssBaseline />
        <AppBar position="static">
          <Toolbar className={classes.toolbar}>
            <Link to="/" className={classes.link}>
              <div className={classes.imageDiv} />
            </Link>
            <Tabs
              value={location.pathname}
              onChange={this.handleChange}
              className={classes.tabs}
              variant="scrollable"
              scrollButtons="auto"
            >
              {Routes.map((route, index) => {
                if (route.redirect) {
                  return null;
                }
                if (route.type === "volunteer") {
                  return (
                    volunteer && (
                      <Tab
                        icon={route.icon}
                        label={route.name}
                        name={route.name}
                        value={route.path}
                        key={route.path}
                        component={Link}
                        aria-label={route.name}
                        to={route.path}
                        replace={location.pathname === newLocation.pathname}
                      />
                    )
                  );
                }
                if (route.type === "admin" || route.type === "volunteer") {
                  return (
                    authenticated && (
                      <Tab
                        icon={route.icon}
                        label={route.name}
                        name={route.name}
                        value={route.path}
                        key={route.path}
                        aria-label={route.name}
                        component={Link}
                        to={route.path}
                        replace={location.pathname === newLocation.pathname}
                      />
                    )
                  );
                }
                return (
                  <Tab
                    icon={!isWidthUp("sm", this.props.width) && route.icon}
                    label={isWidthUp("sm", this.props.width) && route.name}
                    value={route.path}
                    key={route.path}
                    aria-label={route.name}
                    component={Link}
                    to={route.path}
                    replace={location.pathname === newLocation.pathname}
                  />
                );
              })}
            </Tabs>
          </Toolbar>
        </AppBar>

        <main id="main" className={classes.content}>
          <Switch>
            {Routes.map((route, key) => {
              if (route.redirect) {
                return <Redirect from={route.path} to={route.to} key={key} />;
              }
              return (
                <Route
                  exact
                  path={route.path}
                  component={route.component}
                  key={key}
                />
              );
            })}
          </Switch>
        </main>
      </React.Fragment>
    );
  }
}

IconLabelTabs.propTypes = {
  classes: PropTypes.object.isRequired
};

export default withWidth()(withStyles(styles)(withRouter(IconLabelTabs)));
